import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';

@NgModule({
  imports: [RouterModule.forChild([
    { path: '', data: { breadcrumb : '' }, loadChildren: () => import('./anamnese-configuracao-listar/anamnese-configuracao-listar.module').then(m => m.AnamneseConfiguracaoListarModule) },
    { path: 'inserir', data: { breadcrumb : 'Novo' }, loadChildren: () => import('./anamnese-configuracao-inserir/anamnese-configuracao-inserir.module').then(m => m.AnamneseConfiguracaoInserirModule) },
    { path: 'editar', data: { breadcrumb : 'Editar' }, loadChildren: () => import('./anamnese-configuracao-editar/anamnese-configuracao-editar.module').then(m => m.AnamneseConfiguracaoEditarModule) }

  ])],
  exports: [RouterModule]
})
export class AnamneseConfiguracaoRoutingModule { }
